const ROUTES = {
  1: "/",
  2: "/shop",
  3: "/supllier",
  4: "/admin-panel",
  5: "/super-admin-panel",
  6: "/super-admin-panel/upload-excel",
};

const ACCESS_LEVEL = {
  //* super admin
  100: "sa_product_management",
  101: "sa_user_management",
  102: "sa_options_management",
  103: "sa_orders_management",
  sa_product_management: 100,
  sa_user_management: 101,
  sa_options_management: 102,
  sa_orders_management: 103,

  //* admin
  200: "a_main_management",
  201: "a_define_product",
  202: "a_define_basket",
  203: "a_orders_management",
  204: "a_sent_orders_management",
  a_main_management: 200,
  a_define_product: 201,
  a_define_basket: 202,
  a_orders_management: 203,
  a_sent_orders_management: 204,
};

export { ROUTES, ACCESS_LEVEL };
